import Carousel from 'react-multi-carousel';
import 'react-multi-carousel/lib/styles.css';
import colorSharp from "../assets/img/color-sharp.png";
import meter1 from "../assets/img/SkillsIcon/meter1.svg";
import meter2 from "../assets/img/SkillsIcon/meter2.svg";
import meter3 from "../assets/img/SkillsIcon/meter3.svg";
import github from "../assets/img/SkillsIcon/github.svg";
import react from "../assets/img/SkillsIcon/logo.svg";
import php from "../assets/img/SkillsIcon/php.png";
import docker from "../assets/img/SkillsIcon/docker.svg";
import js from "../assets/img/SkillsIcon/js.svg";
import npm from "../assets/img/SkillsIcon/npm.svg";
import linux from "../assets/img/SkillsIcon/linux.svg";
import postgres from "../assets/img/SkillsIcon/postgres.svg";
import mysql from "../assets/img/SkillsIcon/mysql.svg";
import composer from "../assets/img/SkillsIcon/composer.png";
import java from "../assets/img/SkillsIcon/java.svg";
import laravel from "../assets/img/SkillsIcon/laravel.svg";
import aws from "../assets/img/SkillsIcon/aws.svg";
import spring from "../assets/img/SkillsIcon/spring.png";
import {Col, Container, Row} from "react-bootstrap";
import typescript from "../assets/img/SkillsIcon/typescript.png";

export const Skills = () => {
    const responsive = {
        superLargeDesktop: {
            // the naming can be any, depends on you.
            breakpoint: { max: 4000, min: 3000 },
            items: 5
        },
        desktop: {
            breakpoint: { max: 3000, min: 1024 },
            items: 3
        },
        tablet: {
            breakpoint: { max: 1024, min: 464 },
            items: 2
        },
        mobile: {
            breakpoint: { max: 464, min: 0 },
            items: 1
        }
    };

    return (
        <section className="skill" id="skills">
            <div className="container">
                <div className="row">
                    <div className="col-12">
                        <div className="skill-bx wow zoomIn">
                            <h2>Skills</h2>
                            <p>
                                Backend-focused developer with a strong emphasis on clean architecture and scalable solutions.<br />
                                Experienced with PHP, Java, JavaScript/TypeScript, modern frameworks, relational databases,
                                containers, cloud services, and DevOps practices to build robust and efficient applications.
                            </p>
                            <Carousel responsive={responsive} infinite={true} className="owl-carousel owl-theme skill-slider">

                                <div className="item">
                                    <img src={java} alt="Java" />
                                    <h5>Java</h5>
                                </div>

                                <div className="item">
                                    <img src={php} alt="PHP" />
                                    <h5>PHP</h5>
                                </div>

                                <div className="item">
                                    <img src={js} alt="JavaScript" />
                                    <h5>JavaScript</h5>
                                </div>

                                <div className="item">
                                    <img src={typescript} alt="TypeScript" />
                                    <h5>TypeScript</h5>
                                </div>

                                <div className="item">
                                    <img src={laravel} alt="Laravel" />
                                    <h5>Laravel</h5>
                                </div>

                                <div className="item">
                                    <img src={spring} alt="Spring" />

                                    <h5>Spring</h5>
                                </div>

                                <div className="item mx-auto">
                                    <br/>
                                    <img src={react} alt="React" />
                                    <br/>
                                    <br/>
                                    <br/>
                                    <h5>React</h5>
                                </div>

                                <div className="item">
                                    <img src={linux} alt="Linux" />
                                    <h5>Linux</h5>
                                </div>

                                <div className="item">
                                    <img src={docker} alt="Docker" />
                                    <h5>Docker</h5>
                                </div>

                                <div className="item">
                                    <img src={postgres} alt="Postgres" />
                                    <h5>Postgres</h5>
                                </div>

                                <div className="item">
                                    <img src={mysql} alt="MySQL" />
                                    <h5>MySQL</h5>
                                </div>

                                <div className="item">
                                    <img src={github} alt="GitHub" />
                                    <h5>GitHub</h5>
                                </div>

                                <div className="item">
                                    <br/>
                                    <br/>
                                    <img src={aws} alt="AWS" />
                                    <br/>
                                    <br/>
                                    <br/>
                                    <h5>AWS</h5>
                                </div>


                            </Carousel>
                        </div>
                    </div>
                </div>
            </div>
            <img className="background-image-left" src={colorSharp} alt="Image5" />
        </section>
    )
}
